import { createContext } from 'react';

const surfboardContext = createContext();

export default surfboardContext;